import FpLogo from "@/assets/fp-logo.svg";
import { Markdown } from "@/components/CodeGen";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
// import { useCurrentFileTree } from "@/lib/hooks/useFilesystem";
import { useWebSocketMessaging } from "@/lib/hooks/useWebSocketMessaging";
// import { buildFileTree } from "@/lib/utils/file-tree-utils";
import { useMessageStore } from "@/state/stores";
import { Link } from "@tanstack/react-router";

import {
  Activity,
  // ChevronDown,
  ChevronRight,
  // Clock,
  Cloud,
  // FileCode,
  // Folder,
  MessageSquare,
  Search,
  Send,
  // TrendingUp,
  User,
} from "lucide-react";
import {
  // useMemo,
  useState,
} from "react";
import { useStickToBottom } from "use-stick-to-bottom";
import { useShallow } from "zustand/react/shallow";
import { CompactDeploysContent } from "../CompactDeploys";
import { CompactInspectorContent } from "../CompactInspector";
import { CompactTracesList } from "../CompactTraces";

interface ProjectOverviewTabProps {
  projectId: string;
}

export function ProjectOverviewTab({ projectId }: ProjectOverviewTabProps) {
  // State for collapsible sections and input
  // const [expandedSections, setExpandedSections] = useState({
  //   debugChat: true,
  //   inspector: true,
  // });
  const [inputValue, setInputValue] = useState("");

  // Fetch real file tree data
  // const { data: currentFiles } = useCurrentFileTree(projectId);

  // Get real messages and WebSocket messaging
  const { sendMessage, connectionStatus } = useWebSocketMessaging();
  const { messages } = useMessageStore(
    useShallow((state) => ({
      messages: state.messages,
    })),
  );

  // Auto-scroll to bottom when new messages arrive
  const { scrollRef, contentRef } = useStickToBottom();

  // const toggleSection = (section: keyof typeof expandedSections) => {
  //   setExpandedSections((prev) => ({
  //     ...prev,
  //     [section]: !prev[section],
  //   }));
  // };

  // // Mock data representing enhanced project state

  // const quickStats = {
  //   requestsToday: 47,
  //   avgResponseTime: 156,
  //   successRate: 96.8,
  //   activeTools: 8,
  // };

  // const recentActivity = [
  //   {
  //     id: "1",
  //     type: "connection",
  //     message: "Claude Code connected",
  //     timestamp: "5 min ago",
  //     status: "success",
  //   },
  //   {
  //     id: "2",
  //     type: "deployment",
  //     message: "Files synced successfully",
  //     timestamp: "2 min ago",
  //     status: "success",
  //   },
  //   {
  //     id: "3",
  //     type: "usage",
  //     message: "Tool 'search_files' called 3 times",
  //     timestamp: "8 min ago",
  //     status: "info",
  //   },
  //   {
  //     id: "4",
  //     type: "error",
  //     message: "Rate limit exceeded for client",
  //     timestamp: "15 min ago",
  //     status: "warning",
  //   },
  // ];

  // // Create file status from real file tree data
  // const fileStatus = useMemo(() => {
  //   if (!currentFiles) {
  //     return [];
  //   }

  //   // For current files, we don't have timestamps, so pass undefined
  //   const fileTree = buildFileTree(currentFiles);

  //   // Flatten the tree to get all files (not folders)
  //   const flattenFiles = (
  //     nodes: typeof fileTree,
  //   ): Array<{ name: string; status: string; lastModified: string }> => {
  //     const files: Array<{
  //       name: string;
  //       status: string;
  //       lastModified: string;
  //     }> = [];

  //     for (const node of nodes) {
  //       if (node.type === "file") {
  //         files.push({
  //           name: node.path,
  //           status: "synced", // All files from backend are considered synced
  //           lastModified: node.modified || "Unknown",
  //         });
  //       }
  //       if (node.children) {
  //         files.push(...flattenFiles(node.children));
  //       }
  //     }

  //     return files;
  //   };

  //   // Get all files and limit to most recent 8 for the overview
  //   return flattenFiles(fileTree)
  //     .sort((a, b) => a.name.localeCompare(b.name))
  //     .slice(0, 8);
  // }, [currentFiles]);

  return (
    <div className="space-y-6">
      {/* One, two or four Column Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-6">
        {/* Column - MCP Inspector */}
        <Card>
          <CardHeader className="flex flex-row items-center justify-between pb-3">
            <CardTitle className="flex items-center gap-2">
              <Search className="w-5 h-5" />
              MCP Inspector
            </CardTitle>
            <Button variant="outline" size="sm" asChild>
              <Link
                to="/projects/$projectId"
                params={{ projectId }}
                search={{ tab: "inspector" }}
              >
                <ChevronRight className="w-4 h-4" />
              </Link>
            </Button>
          </CardHeader>
          <CardContent>
            <CompactInspectorContent projectId={projectId} />
          </CardContent>
        </Card>

        {/* Column - Debug Chat */}
        <Card className="grid grid-rows-[auto_minmax(0,1fr)]">
          <CardHeader className="flex flex-row items-center justify-between pb-3">
            <CardTitle className="flex items-center gap-2">
              <MessageSquare className="w-5 h-5" />
              Chat
            </CardTitle>
            <Button variant="outline" size="sm" asChild>
              <Link
                to="/projects/$projectId"
                params={{ projectId }}
                search={{ tab: "debug-chat" }}
              >
                <ChevronRight className="w-4 h-4" />
              </Link>
            </Button>
          </CardHeader>
          {/* <CardContent className="grid grid-rows-[minmax(1fr,400px)_auto] min-h-0"> */}
          <CardContent className="grid grid-rows-[1fr_auto] min-h-0">
            {/* Recent Messages Preview */}
            <div
              ref={scrollRef}
              className="overflow-y-auto min-h-0 max-h-[700px]"
            >
              <div ref={contentRef} className="space-y-2">
                {messages.length === 0 ? (
                  <div className="flex items-center justify-center h-16 text-muted-foreground">
                    <div className="text-center">
                      <MessageSquare className="w-6 h-6 mx-auto mb-2 opacity-50" />
                      <p className="text-sm">No chat messages yet</p>
                      <p className="text-xs">Start a conversation below</p>
                    </div>
                  </div>
                ) : (
                  messages.slice(-3).map((message) => {
                    const isUser = message.sender === "user";
                    return (
                      <div
                        key={message.id}
                        className={`flex items-start gap-2 text-sm ${
                          isUser ? "flex-row-reverse" : ""
                        }`}
                      >
                        <div className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center">
                          {isUser ? (
                            <User className="w-3 h-3 text-primary" />
                          ) : (
                            <FpLogo className="w-3 h-3 text-muted-foreground" />
                          )}
                        </div>
                        <div className="flex-1 min-w-0 max-w-[65%]">
                          <div
                            className={`flex items-center gap-2 mb-1 ${isUser ? "justify-end" : ""}`}
                          >
                            <span className="font-medium text-xs text-muted-foreground uppercase">
                              {message.sender}
                            </span>
                            <span className="text-xs text-muted-foreground">
                              {new Date(message.createdAt).toLocaleTimeString()}
                            </span>
                            {message.parts?.some(
                              (p) => p.type === "tool-call",
                            ) && (
                              <code className="text-xs font-mono bg-muted px-1.5 py-0.5 rounded">
                                tool used
                              </code>
                            )}
                          </div>
                          <div
                            // className={`rounded-lg px-3 py-2 text-sm line-clamp-2 ${
                            className={`rounded-lg px-3 py-2 text-sm ${
                              isUser
                                ? "bg-primary text-primary-foreground ml-auto"
                                : "bg-muted/50 text-foreground mr-auto"
                            }`}
                          >
                            {isUser ? (
                              <p>{message.content}</p>
                            ) : (
                              // For agent messages, render markdown and also check for text parts
                              <>
                                {message.content && (
                                  <Markdown className="prose prose-xs max-w-none [&>h2]:text-sm [&>h2]:font-medium [&>h2]:mb-1 [&>*]:text-inherit">
                                    {message.content}
                                  </Markdown>
                                )}
                                {message.parts?.map((part) => {
                                  if (part.type === "text" && part.content) {
                                    return (
                                      <Markdown
                                        key={part.id}
                                        className="prose prose-xs max-w-none [&>h2]:text-sm [&>h2]:font-medium [&>h2]:mb-1 [&>*]:text-inherit"
                                        isStreaming={
                                          part.status === "streaming"
                                        }
                                      >
                                        {part.content}
                                      </Markdown>
                                    );
                                  }
                                  return null;
                                })}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>

            {/* Continue Chat */}
            <div className="pt-3 border-t flex-shrink-0">
              <div className="flex gap-2">
                <Input
                  placeholder=""
                  className="flex-1"
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      if (inputValue.trim()) {
                        sendMessage(inputValue.trim());
                        setInputValue("");
                      }
                    }
                  }}
                />
                <Button
                  size="sm"
                  onClick={() => {
                    if (inputValue.trim()) {
                      sendMessage(inputValue.trim());
                      setInputValue("");
                    }
                  }}
                  disabled={
                    !inputValue.trim() || connectionStatus !== "connected"
                  }
                >
                  <Send className="w-4 h-4" />
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Column - MCP Traces */}
        <Card>
          <CardHeader className="flex flex-row items-center justify-between pb-3">
            <CardTitle className="flex items-center gap-2">
              <Activity className="w-5 h-5" />
              MCP Traces
            </CardTitle>
            <Button variant="outline" size="sm" asChild>
              <Link
                to="/projects/$projectId"
                params={{ projectId }}
                search={{ tab: "observability" }}
              >
                <ChevronRight className="w-4 h-4" />
              </Link>
            </Button>
          </CardHeader>
          <CardContent>
            <CompactTracesList projectId={projectId} />
          </CardContent>
        </Card>

        {/*  Column - Recent Deploys */}
        <Card>
          <CardHeader className="flex flex-row items-center justify-between pb-3">
            <CardTitle className="flex items-center gap-2">
              <Cloud className="w-5 h-5" />
              Recent Deploys
            </CardTitle>
            <Button variant="outline" size="sm" asChild>
              <Link
                to="/projects/$projectId"
                params={{ projectId }}
                search={{ tab: "deploys" }}
              >
                <ChevronRight className="w-4 h-4" />
              </Link>
            </Button>
          </CardHeader>
          <CardContent>
            <CompactDeploysContent projectId={projectId} />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

// {/* File Status Overview */}
// <Card>
//   <CardHeader className="flex flex-row items-center justify-between px-6 pb-2">
//     <CardTitle className="flex items-center gap-2">
//       <FileCode className="w-5 h-5" />
//       File Status ({fileStatus.length})
//     </CardTitle>
//     <Button variant="outline" size="sm" asChild>
//       <Link
//         to="/projects/$projectId"
//         params={{ projectId }}
//         search={{ tab: "files" }}
//       >
//         <Folder className="w-4 h-4 mr-1" />
//         Browse All
//       </Link>
//     </Button>
//   </CardHeader>
//   <CardContent className="">
//     {fileStatus.length === 0 ? (
//       <div className="flex items-center justify-center h-24 text-muted-foreground">
//         <div className="text-center">
//           <FileCode className="w-6 h-6 mx-auto mb-2 opacity-50" />
//           <p className="text-sm">No files found</p>
//         </div>
//       </div>
//     ) : (
//       fileStatus.map((file) => (
//         <div
//           key={`${file.name}-${file.status}`}
//           className="flex items-center justify-between p-2 rounded hover:bg-muted/50"
//         >
//           <div className="flex items-center gap-2">
//             <div
//               className={`w-2 h-2 rounded-full ${
//                 file.status === "synced"
//                   ? "bg-success"
//                   : "bg-warning"
//               }`}
//             />
//             <span className="text-sm font-mono">{file.name}</span>
//           </div>
//           <span className="text-xs text-muted-foreground">
//             {file.lastModified}
//           </span>
//         </div>
//       ))
//     )}
//   </CardContent>
// </Card>

// {/* Recent Activity & Stats */}
// <Card>
//   <CardHeader>
//     <CardTitle className="flex items-center gap-2">
//       <Activity className="w-5 h-5" />
//       Recent Activity & Stats (dummy data)
//     </CardTitle>
//   </CardHeader>
//   <CardContent className="space-y-4">
//     {/* Quick Stats */}
//     <div className="grid grid-cols-2 gap-4 p-3 bg-muted/50 rounded-lg">
//       <div className="text-center">
//         <div className="flex items-center justify-center gap-1">
//           <p className="text-lg font-bold">
//             {quickStats.requestsToday}
//           </p>
//           <TrendingUp className="w-4 h-4 text-primary" />
//         </div>
//         <p className="text-xs text-muted-foreground">
//           Requests Today
//         </p>
//       </div>
//       <div className="text-center">
//         <div className="flex items-center justify-center gap-1">
//           <p className="text-lg font-bold">
//             {quickStats.avgResponseTime}ms
//           </p>
//           <Clock className="w-4 h-4 text-success" />
//         </div>
//         <p className="text-xs text-muted-foreground">
//           Avg Response
//         </p>
//       </div>
//     </div>

//     {/* Activity Log */}
//     <div className="space-y-3">
//       {recentActivity.map((activity) => (
//         <div key={activity.id} className="flex items-start gap-3">
//           <div
//             className={`w-2 h-2 rounded-full mt-2 ${
//               activity.status === "success"
//                 ? "bg-success"
//                 : activity.status === "warning"
//                   ? "bg-warning"
//                   : activity.status === "error"
//                     ? "bg-destructive"
//                     : "bg-primary"
//             }`}
//           />
//           <div className="flex-1 min-w-0">
//             <p className="text-sm">{activity.message}</p>
//             <p className="text-xs text-muted-foreground">
//               {activity.timestamp}
//             </p>
//           </div>
//         </div>
//       ))}
//     </div>
//   </CardContent>
// </Card>
